/**
 * Description: 校验字符的正则表达式
 * @author: lhc
 * @date: 2022/1/10 14:27
 */

const CharRegExp = {

  /*  0 汉字                                      */ _N_0: `^[\u4e00-\u9fa5]{0,}$`,
  /*  1 英文和数字                                */ _N_1: `^[A-Za-z0-9]+$`,  // ^[A-Za-z0-9]{4,40}$
  /*  2 长度为3-20的所有字符                      */ _N_2: `^.{3,20}$`,
  /*  3 由26个英文字母组成的字符串                */ _N_3: `^[A-Za-z]+$`,
  /*  4 由26个大写英文字母组成的字符串            */ _N_4: `^[A-Z]+$`,
  /*  5 由26个小写英文字母组成的字符串            */ _N_5: `^[a-z]+$`,
  /*  6 由数字和26个英文字母组成的字符串          */ _N_6: `^[A-Za-z0-9]+$`,
  /*  7 由数字、26个英文字母或者下划线组成的字符串*/ _N_7: `^\\w+$`, // ^\w{3,20}$
  /*  8 中文、英文、数字包括下划线                */ _N_8: `^[\u4E00-\u9FA5A-Za-z0-9_]+$`,
  /*  9 中文、英文、数字但不包括下划线等符号      */ _N_9: `^[\u4E00-\u9FA5A-Za-z0-9]+$`, // ^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$
  /* 10 可以输入含有^%&',;=?$\"等字符             */ _N_10: `[^%&',;=?$\x22]+`,
  /* 11 禁止输入含有~的字符                       */ _N_11: `[^~\x22]+`,
}

export default CharRegExp
